<template>
    <v-layout row wrap>
        <v-flex md4>
            <v-text-field
                    class="search-box--height"
                    height="41"
                    v-model="sourceSearch"
                    label="Search Here"
                    solo
                    flat
                    clearable
                    background-color="#f4f4f4"
            ></v-text-field>
        </v-flex>
        <v-flex md3>
            <v-btn
                    depressed
                    color="bindezcolor"
                    class="mt-0 "
                    small
                    dark
            >
                <span class="text-capitalize subheading font-weight-regular">Search</span>
            </v-btn>
        </v-flex>
        <v-flex md5 class="text-xs-right">
            <v-btn
                    :loading="!fetchSourcesReady"
                    class="mt-0"
                    depressed
                    color="bindezcolor"
                    :dark="!authenticatedUser.is_user"
                    :disabled="authenticatedUser.is_user"
                    large
                    @click="dialog = true"
            >
                <v-icon>
                    add
                </v-icon>
                <span class="text-capitalize subheading font-weight-regular">Add Source</span>
            </v-btn>
            <!-- :disabled="(!selectedSources.length > 0 && !selectedPageMonitorSource) || authenticatedUser.is_user" -->
            <v-btn
                    depressed
                    class="mr-0 mt-0"
                    @click="deleteMonitorSource"
                    color="secondarycolor"
                    :dark="!authenticatedUser.is_user"
                    :disabled="(selectedSources.length === 0 && !selectedPageMonitorSource) || authenticatedUser.is_user"
                    large
            >
                <span class="text-capitalize subheading font-weight-regular">Delete Source</span>
            </v-btn>
        </v-flex>
        <v-flex md12>
            <v-dialog
                    v-model="dialog"
                    max-width="1000"
                    persistent
            >
                <v-card flat>
                    <v-layout row wrap pa-3>
                        <v-flex sm5>
                            <v-text-field
                                    class="search-box--height"
                                    height="41"
                                    ref="sourceSearchText"
                                    browser-autocomplete="new-password"
                                    clearable
                                    @click:clear="() => avaiSourceSearch = ''"
                                    label="Search Here"
                                    solo
                                    flat
                                    background-color="#f4f4f4"
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex sm2>
                            <v-btn
                                    depressed
                                    color="bindezcolor"
                                    @click="searchSources"
                                    class="mt-0 "
                                    small
                                    dark
                            >
                                <span class="text-capitalize subheading font-weight-regular">Search</span>
                            </v-btn>
                        </v-flex>
                        <v-flex sm5 text-xs-center>
                            <div>
                                <v-radio-group v-model="sourcesFilter" row hide-details class="mt-1">
                                    <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`All(${avaiSources.length})`" value="all"></v-radio>
                                    <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`Select(${selectedPageMonitorSource ? 1 : selectedSources.length})`" value="select"></v-radio>
                                    <v-radio :ripple="false" class="custom-checkbox-size custom-position" color="bindezcolor" :label="`Unselect(${unSelectSources.length})`" value="unselect"></v-radio>
                                </v-radio-group>
                            </div>
                        </v-flex>
                        <v-flex sm12>
                            <!-- v-model="selectedSources" -->
                            <v-data-table
                                    :search="avaiSourceSearch"
                                    :loading="!fetchSourcesReady"
                                    :key="selectedSources.length"
                                    :custom-filter="customSourceFilter"
                                    :items="avaiSources"
                                    :headers="sourcesAddHeaders"
                                    :pagination.sync="pagination"
                                    item-key="id"
                                    select-all
                                    class="custom-checkbox-size"
                                    hide-actions
                            >
                                <v-progress-linear slot="progress" color="bindezcolor" indeterminate></v-progress-linear>
                                <template
                                        slot="headers"
                                        slot-scope="props"
                                >
                                    <tr>
                                        <th>
<!--                                            :input-value="props.all"-->
                                            <v-checkbox
                                                    v-show="monitorType === 'keyword'"
                                                    :input-value="avaiSources.length === selectedSources.length"
                                                    :indeterminate="props.indeterminate"
                                                    color="bindezcolor"
                                                    hide-details
                                                    @click.stop="toggleAll"
                                                    :disabled="monitorType === 'page'"
                                            ></v-checkbox>
                                        </th>
                                        <th class="subheading font-weight-regular text-xs-left"
                                            v-for="header in props.headers" :key="header.text">
                                            {{ header.text}}
                                        </th>
                                    </tr>
                                </template>
                                <template
                                        slot="items" slot-scope="props"
                                >
                                    <tr :active="props.selected">
                                        <td>
                                            <v-checkbox
                                                    v-show="monitorType === 'keyword'"
                                                    :disabled="disableOtherSources(props.item.facebookid)"
                                                    :ripple="false"
                                                    :key="props.item.facebookid"
                                                    :value="props.item.facebookid"
                                                    class="custom-checkbox-size"
                                                    color="bindezcolor"
                                                    hide-details
                                                    v-model="selectedSources"
                                            ></v-checkbox>
                                            <v-radio-group
                                                    v-show="monitorType === 'page'"
                                                    row
                                                    class="custom-radio-size"
                                                    v-model="selectedPageMonitorSource"
                                                    hide-details
                                            >
                                                <v-radio :key="props.item.facebookid" :value="props.item.facebookid"></v-radio>
                                            </v-radio-group>
                                        </td>
                                        <td class="body-2 table-text--color"><span
                                                class="zawgyi">{{props.item.name}}</span></td>
                                        <td class="body-2 table-text--color">{{props.item.facebookid}}</td>
                                        <td class="body-2">
                                            <a
                                                    target="_blank"
                                                    style="text-decoration: none; color:#000;"
                                                    @click.stop
                                                    :href="props.item.links">
                                                <span class="zawgyi table-text--color">{{props.item.name}}</span>
                                            </a>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                        <v-flex sm12>
                            <div class="text-xs-center">
                                <v-pagination
                                        v-if="sourcesFilter === 'all' || (sourcesFilter === 'select' && selectedSources.length > 0) || (sourcesFilter === 'unselect' && selectedSources.length !== avaiSources.length)"
                                        circle
                                        color="bindezcolor"
                                        v-model="pagination.page"
                                        :total-visible="8"
                                        :length="pages">

                                </v-pagination>
                            </div>
                        </v-flex>
                        <v-flex sm12 text-xs-right>
                            <v-btn
                                color="bindezcolor"
                                @click="cancelSourceAdd"
                                outline
                            >
                                <span class="text-capitalize body1 font-weight-regular" style="color: #000;">Cancel</span>
                            </v-btn>
                            <v-btn
                                    color="bindezcolor"
                                    @click="saveSources"
                                    dark
                            >
                                <span class="text-capitalize">Save</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-dialog>
            <v-data-table
                    hide-actions
                    v-model="selectedMonitorSources"
                    :items="monitorSources"
                    :search="sourceSearch"
                    :pagination.sync="monitorSourcePagination"
                    :headers="headers"
                    :loading="(!create && (!monitorFetchReady || !fetchSourcesReady))"
                    item-key="id"
                    class="elevation-2 custom-checkbox-size"
                    select-all
            >
                <template slot="no-data">
                    <v-alert :value="!monitorSources.length > 0" color="error" icon="warning">
                        <span>Please, add source</span>
                    </v-alert>
                </template>
                <v-progress-linear slot="progress" color="bindezcolor" height="2" indeterminate></v-progress-linear>
                <template
                        slot="headers"
                        slot-scope="props"
                >
                    <tr>
                        <th>
                            <v-checkbox
                                    v-show="monitorType === 'keyword'"
                                    :input-value="props.all"
                                    :indeterminate="props.indeterminate"
                                    @click.stop="toggleMonitorSource"
                                    color="bindezcolor"
                                    hide-details
                            ></v-checkbox>
                        </th>
                        <th class="text-xs-left font-weight-regular subheading" v-for="header in props.headers"
                            :key="header.text">
                            {{ header.text}}
                        </th>
                    </tr>
                </template>
                <template
                        slot="items"
                        slot-scope="props"
                >
                    <tr :active="props.selected">
                        <td>
                            <v-checkbox
                                    v-show="monitorType === 'keyword'"
                                    class="custom-checkbox-size"
                                    v-model="props.selected"
                                    color="bindezcolor"
                                    hide-details
                            ></v-checkbox>
                        </td>
                        <td class="body-2 table-text--color">
                            <span class="zawgyi">{{props.item.name}}</span>
                        </td>
                        <td class="body-2 table-text--color">{{props.item.facebookid}}</td>
                        <td class="body-2 table-text--color">
                            <!-- <span class="zawgyi">{{props.item.name}}</span> -->
                            <a
                                    target="_blank"
                                    style="text-decoration: none; color:#000;"
                                    @click.stop
                                    :href="props.item.links">
                                <span class="zawgyi table-text--color">{{props.item.name}}</span>
                            </a>
                        </td>
                        <td>
                            <v-btn
                                    color="secondarycolor"
                                    outline
                                    @click.stop="copySource(props.item.links)"
                            ><span class="text-capitalize">Copy</span></v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <v-flex xs12>
                <div class="text-xs-center">
                    <v-pagination
                            v-show="monitorSources.length"
                            circle
                            color="bindezcolor"
                            v-model="monitorSourcePagination.page"
                            :total-visible="8"
                            :length="monitorSourcePages">
                    </v-pagination>
                </div>
            </v-flex>
        </v-flex>
        <v-flex xs12 text-xs-right>
            <v-btn
                    :disabled="sourceSectionInvalid"
                    depressed
                    color="bindezcolor"
                    @click="monitorAction"
                    :dark="!sourceSectionInvalid"
                    :loading="processing"
            >
                <span class="text-capitalize">{{ create ? 'Next' : 'Update Monitor' }}</span>
            </v-btn>
        </v-flex>
        <v-snackbar
                v-model="snackbar"
                color="bindezcolor"
                top
                :timeout="3000"
        >
            <span class="font-weight-bold">Copied to clipboard!!</span>
            <v-btn
                    @click="snackbar = false"
                    dark
                    flat
            ><span class="text-capitalize">Close</span></v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex'
	import sourceSection from '@/mixins/sourceSection'
	import * as _ from 'lodash'
	import authCurrentUser from "../../mixins/authCurrentUser";

	export default {
		name: "SourcesSection",
        props: ['create','processing'],
		data() {
			return {
				dialog: false,
				sourcesReady: false,
                currentPage: 1,
				selectedMonitorSources: [],
				selectedSources: [],
                selectedPageMonitorSource:"",
				sourceSearch: '',
				avaiSourceSearch: '',
				monitorSourcePagination: {
					rowsPerPage: 100
				},

				pagination: {
					rowsPerPage: 20,
                    totalItems: 595
				},
                allCurrentPage: 1,
                selectCurrentPage: 1,
                unselectCurrentPage: 1,
				headers: [
					{text: "Name", value: "name", sortable: false},
					{text: "FacebookID", value: "facebookid", sortable: false},
					{text: "Links", value: "links", sortable: false},
					{text: "Options", value: "name", sortable: false}
				],
				sourcesAddHeaders: [
					{text: "Name", value: "name", sortable: false},
					{text: "FacebookID", value: "facebookid", sortable: false},
					{text: "Links", value: "links", sortable: false},
				],
				sourcesFilter: "all",
			}
		},
		mixins: [sourceSection, authCurrentUser],
		computed: {
			...mapState([
				'monitor'
			]),

			...mapState('monitors', [
				'monitorFetchReady',
				'fetchSourcesReady',
				'sourceSectionInvalid',
                'sources',
                'monitorType'
			]),

			...mapState('monitors', {
				monitorAddedPages: state => state.pages
			}),

			pages() {
				if (this.pagination.rowsPerPage == null ||
					this.pagination.totalItems == null
				) return 0

				return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
			},

			monitorSourcePages() {
				if (this.monitorSourcePagination.rowsPerPage == null ||
					this.monitorSourcePagination.totalItems == null
				) return 0

				return Math.ceil(this.monitorSourcePagination.totalItems / this.monitorSourcePagination.rowsPerPage);
			},

            facebookSources(){
				let sources = this.sources.map(source => source.split(":"));
				return sources.map(([name, id]) =>({
                    id,
                    name,
                    facebookid:id,
                    links: `https://www.facebook.com/${id}`
                }))
            },

			avaiSources() {
				return this.facebookSources;
			},

            unSelectSources(){
				//return _.differenceBy(this.avaiSources, this.selectedSources, "id")
                let sources = this.monitorType === 'page' ? this.selectedPageMonitorSource : this.selectedSources;
                return this.avaiSources.filter(source => !_.includes(sources, source.facebookid));
            },

			monitorSources: {
				get() {
					return this.avaiSources.filter(source => this.monitorAddedPages.includes(source.id));
				},
				set(pages) {
					this.setMonitorSources(pages);
				}
			}
		},

		methods: {
			...mapMutations('monitors', [
				'setMonitorSources',
                'setFetchSourcesReady',
				'setSourceSectionValidation'
			]),

			...mapActions('monitors', [
				'fetchSources',
			]),

			goToSource(item) {
				window.open(item.links)
			},

			monitorAction() {
				if (this.selectedSources.length > 0 || this.selectedPageMonitorSource) {
					if (!this.create) {
						this.$emit('next', 'update')
					} else {
						this.$emit('next')
					}
				}
			},

			cancelSourceAdd(){
				// this.selectedSources = this.avaiSources.filter(source => this.monitorAddedPages.includes(source.id));
				if (this.monitorType === 'page')
					this.selectedPageMonitorSource = this.monitorSources.length > 0 ? this.monitorSources[0].id : "";
				else
					this.selectedSources = this.avaiSources.filter(source => this.monitorAddedPages.includes(source.id)).map(source => source.id);
				this.dialog = false;
			},

			saveSources(){
				this.$ua.trackEvent("Monitor", "click", `${this.authenticatedUser.email || 'User'} add sources to monitor`);
				// this.monitorSources = this.selectedSources.map(source => source.id);
                this.monitorSources = this.monitorType === 'page' ? [this.selectedPageMonitorSource] : this.selectedSources;
				this.dialog = false;
			},

			deleteMonitorSource() {
				// let sourcesLeft = this.monitorType === 'page' ? [] :this.selectedSources.filter(id => !_.includes(this.selectedMonitorSources, id));
				// this.selectedSources = sourcesLeft;
				// this.monitorSources = sourcesLeft;
				// console.log(sourcesLeft);
				if (this.monitorType === 'page') {
					this.selectedPageMonitorSource = "";
					this.monitorSources = [];
				} else {
					this.selectedSources = this.selectedSources.filter(source => !_.find(this.selectedMonitorSources, ["id", source]));
					this.monitorSources = this.selectedSources.filter(source => !_.find(this.selectedMonitorSources, ["id", source]));
				}
			},

			toggleAll() {
				this.$ua.trackEvent("Monitor", "check", "Toggle All Available Sources");
				this.selectedSources.length ? this.selectedSources = [] : this.selectedSources = this.avaiSources.map(source => source.id);
			},

			toggleMonitorSource() {
				this.$ua.trackEvent("Monitor", "check", "Toggle All Monitor Sources");
				this.selectedMonitorSources.length ? this.selectedMonitorSources = [] : this.selectedMonitorSources = this.avaiSources.filter(source => this.selectedSources.includes(source.id));
			},

            customSourceFilter(items, search, filter){
				let predicate = () => true;

				if(this.sourcesFilter === 'select'){
					// predicate = item => this.selectedSources.some(source => source.id === item.id);
					predicate = this.monitorType === 'page' ? item => item.id === this.selectedPageMonitorSource : item => this.selectedSources.some(id => id === item.id);
                }else if(this.sourcesFilter === 'unselect'){
					predicate = item => this.unSelectSources.some(source => source.id === item.id);
                }

				return items.filter(predicate).filter(i => Object.keys(i).some(j => filter(i[j], search)))
            },

            disableOtherSources(id){
				return this.monitorType === 'page' && this.selectedSources.length === 1 && id !== this.selectedSources[0].facebookid;
            },

            /*
             * vuetify data-table supports inline text-field search(filter row for every key stroke)
             * "searchSources" method is used to submit search term(search take place only when "Search" button click)
            */
            searchSources(){
				this.avaiSourceSearch = this.$refs.sourceSearchText.$refs.input.value;
            }
		},

		watch: {
			sourcesFilter(filter, oldVal) {
				this.avaiSourceSearch = '';
				this.$data[`${oldVal}CurrentPage`] = this.pagination.page;
				if (filter == "all") {
					this.pagination.totalItems = this.avaiSources.length;
					this.pagination.page = this.allCurrentPage;
				} else if (filter == 'select') {
					this.pagination.totalItems = this.selectedSources.length;
					this.pagination.page = this.selectCurrentPage;
				} else if (filter == 'unselect') {
                    this.pagination.totalItems = this.unSelectSources.length;
					this.pagination.page = this.unselectCurrentPage;
				}
			},

			avaiSources(sources) {
				this.sourcesReady = true;
				if (this.monitorType === 'page'){
					let selectedSource = _.find(sources, (source) => this.monitorAddedPages.includes(source.id)) || {};
					this.selectedPageMonitorSource = selectedSource.id;
				}else{
					this.selectedSources = sources.filter(source => this.monitorAddedPages.includes(source.id)).map(source => source.id);
				}
				this.$set(this.pagination, "totalItems", sources.length);
			},

			selectedPageMonitorSource(value) {
				!value ? this.setSourceSectionValidation(true) : this.setSourceSectionValidation(false);
			},

			selectedSources(sources) {
				(!sources.length > 0) ? this.setSourceSectionValidation(true) : this.setSourceSectionValidation(false);
			},

			monitorSources(sources) {
				this.$set(this.monitorSourcePagination, "totalItems", sources.length);
			},

			monitorType() {
				if (this.create){
					this.selectedSources = [];
					this.selectedPageMonitorSource = "";
					this.monitorSources = [];
                }
			}
		},

        created(){
			this.setFetchSourcesReady(false);
			this.fetchSources()
                .then(_ => this.setFetchSourcesReady(true));
        }
	}
</script>

<style scoped>
    .v-btn.v-btn--small, .v-btn.v-btn--large {
        height: 41px;
    }

    .search-box--height.v-text-field.v-text-field--solo .v-input__control {
        min-height: 25px;
    }

    .table-text--color {
        color: rgba(0, 0, 0, 0.6);
    }

    .custom-position{
        margin-right: 7px;
    }
</style>
